<toil-menu>
    <div class="main-container" *ngIf="hasFeatureAccess">
        <ng-container *ngIf="isLoading; else loaded">
            <ngx-skeleton-loader
                count="5"
                [theme]="{
                    'height.px': 50
                }"
            ></ngx-skeleton-loader>
        </ng-container>
        <ng-template #loaded>
            <div class="content" *ngIf="!isLoading">
                <div class="main-content">
                    <div *ngIf="this.viewState == eTimeOffViewState.ADD_TYPE">
                        <add-toil [refreshListener]="this"></add-toil>
                    </div>

                    <div *ngIf="this.viewState == eTimeOffViewState.EDIT_TYPE">
                        <edit-toil  [timeOffTypeId]="toilTypeId" [refreshListener]="this"></edit-toil>
                    </div>

                    <div *ngIf="this.viewState == eTimeOffViewState.POLICY">
                        <toil-policy [timeOffType]="toilType" [timeOffPolicyId]="toilPolicyId" [timeOffTypeList]="toilTypeList" [refreshListener]="this"></toil-policy>
                    </div>

                    <div *ngIf="this.viewState == eTimeOffViewState.LIST_TYPES" class="timeoff-workspace">
                        <header class="timeoff-toolbar">
                            <div class="header-copy">
                                <h4>{{ 'TimeOffInLieu' | translate: {Default: "Time Off In Lieu"} }}</h4>
                            </div>

                            <div class="toolbar-actions">
                                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="goToTimeOffPolicy(null,null)" class="k-mr-4">
                                    <mat-icon aria-hidden="false" class="material-icons-outlined white" aria-label="add icon">add</mat-icon>
                                    {{ 'AddTOILPolicy' | translate: {Default: "Add TOIL Policy"} }}
                                </button>

                                <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="goToAdd()">
                                    <mat-icon aria-hidden="false" class="material-icons-outlined white" aria-label="add icon">add</mat-icon>
                                    {{ 'AddTOILType' | translate: {Default: "Add TOIL Type"} }}
                                </button>
                            </div>
                        </header>

                        <div class="list-types-container">
                            <div class="filters-panel">
                                <mat-form-field class="search-field" appearance="outline">
                                    <input matInput
                                           [(ngModel)]="timeOffTypeSearchValue"
                                           placeholder="Search...">
                                    <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="cards-container">
                                <mat-card class="timeoff-card" *ngFor="let timeOffType of toilTypeList | toilTypeSearch:timeOffTypeSearchValue">
                                    <div class="card-header">
                                        <div class="card-header-main" appPreventDoubleClick (throttledClick)="goToEdit(timeOffType.id)">
                                            <div class="type-badge" *ngIf="timeOffType.image">
                                                <img [src]="domSanitizer.bypassSecurityTrustUrl(timeOffType.image)" class="timeoff-type-icon" alt="{{ timeOffType.name }} icon" />
                                            </div>

                                            <div class="type-summary">
                                                <h3
                                                    setColor
                                                    [setColorRules]="[
                                                        {
                                                            color: 'primaryColour',
                                                            events: ['hover']
                                                        }
                                                    ]"
                                                >{{ timeOffType.name }}</h3>
                                                <p>{{ (timeOffType.policies?.length ?? 0) }} polic{{ (timeOffType.policies?.length ?? 0) === 1 ? 'y' : 'ies' }}</p>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            mat-icon-button
                                            aria-label="Delete time off type"
                                            appPreventDoubleClick
                                            (throttledClick)="showDeleteTypeConfirmation(timeOffType.id)"
                                            matTooltip="Delete"
                                            class="delete-button"
                                        >
                                            <mat-icon class="material-icons-outlined">delete</mat-icon>
                                        </button>
                                    </div>

                                    <mat-card-content>
                                        <app-toil-policies-data-grid
                                            [toilType]="timeOffType"
                                            (emitGoToToilPolicy)="goToTimeOffPolicy(timeOffType, $event)"
                                        ></app-toil-policies-data-grid>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</toil-menu>
